import { useEffect, useState } from "react";
import { readStoredFilters } from "./homeFilters";

// Persists filter state to sessionStorage (cleared when the browser/tab session ends),
// as opposed to the app's redux-persist setup which is localStorage-backed and survives
// across sessions - the Home dashboard filters are asked to only persist per-session.
// Shares its read logic with readStoredFilters so the initial page load (Home/index.js,
// which reads storage directly before this hook ever mounts) sees the same value.
const useSessionFilters = (key, initialValue) => {
  const [value, setValue] = useState(() => readStoredFilters(key, initialValue));

  useEffect(() => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // sessionStorage unavailable (e.g. private browsing) - filters just won't persist
    }
  }, [key, value]);

  return [value, setValue];
};

export default useSessionFilters;
